import axios from "../../adminCompenents/config/axiosConfig";
export default class UserService {
  getAllusers = async () => {
    try {
      const response = axios.get("users");
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la création de la users : " + error.message
      );
    }
  };
  createUsers = async (data) => {
    try {
      const response = axios.post("/users", data);
      console.log("response", response);
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la création de la users : " + error.message
      );
    }
  };
  toggleUserStatus = async (id) => {
    try {
      const response = axios.patch(`/users/${id}/toggle-status`);
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la création de la users : " + error.message
      );
    }
  };
  editUsers = async (id, data) => {
    try {
      const response = axios.put(`/users/${id}`, data);
      console.log("response", response.data);
      return response;
    } catch (error) {
      throw new Error("Erreur lors de l'edition du user : " + error.message);
    }
  };

  getUserById = async (id) => {
    try {
      const response = axios.get(`users/user/${id}`);
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la création de la users : " + error.message
      );
    }
  };
  getClients = async () => {
    try {
      const response = axios.get("/users/user/test/clients");
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la récupération des clients : " + error.message
      );
    }
  };
}
